module.exports = __webpack_public_path__ + "img/Iconset_DGBRT--14.96155e43.png";